<template>
  <v-container grid-list-lg fluid>
    <v-layout row align-center>
      <v-flex shrink>
        <v-btn small rounded text @click.stop.prevent="$router.go(-1)">
          <v-icon left>mdi-chevron-left </v-icon>
          <span class="hidden-sm-and-down">Report Selection</span>
        </v-btn>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex shrink class="title text-right">
        Multi Store Sale
      </v-flex>
    </v-layout>

    <!-- <v-btn rounded small text @click.stop.prevent="$router.go(-1)">
      <v-icon left>mdi-chevron-left </v-icon>
      Report Dashboard
    </v-btn> -->

    <!-- <v-layout row wrap>
      <v-flex class="text-h6">Multi Store Sale</v-flex>
    </v-layout> -->
    <v-layout row wrap align-center class="mb-3">
      <!-- <v-flex xs12 md3>
        <v-select outlined dense :items="locations" v-model="selectedLocation" label="Select Store" hide-details
          return-object item-text="businessName"></v-select>
      </v-flex> -->
      <v-flex xs12 md3 shrink>
        <DateTimePicker defaultRange="since7DaysAgo" :range="true" :hideTime="true" v-model="dateTime"
          @submit="closeDatePicker" />

      </v-flex>
      <v-spacer></v-spacer>
      <v-flex shrink>
        <div>{{ dateTime.start | moment('LL') }} - {{ dateTime.end | moment('LL') }}</div>
      </v-flex>
    </v-layout>
    <v-layout column>
      <v-flex>
        <v-card flat outlined>
          <div class="pl-3 pt-3 font-weight-medium">Statistics</div>
          <v-expand-transition>

            <v-layout row wrap v-if="!loading">
              <v-flex v-for="(tile, index) in Object.entries(categoryTiles)">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-container grid-list-lg fluid v-bind="attrs" v-on="on">
                      <v-layout row>
                        <v-flex shrink>
                          <v-avatar size="40" :color="iconColor(tile[0])">
                            <v-icon small :color="iconForeground(tile[0])">{{ iconValue(tile[0]) }}</v-icon>
                          </v-avatar>
                        </v-flex>
                        <v-flex>
                          <v-layout column>
                            <v-flex class="pb-0 title font-weight-bold">

                              <span>{{ nFormatter(tile[1]) }}</span>
                              <!-- <span v-bind="attrs" v-on="on">{{ tile[1] }}</span> -->

                            </v-flex>
                            <v-flex class="pt-0 caption">
                              {{ tile[0] }}
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </template>
                  <span>{{ tile[1] | currency }}</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
            <v-card-text v-else>
              <v-progress-linear :indeterminate="true"></v-progress-linear>
            </v-card-text>
          </v-expand-transition>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card flat outlined>
          <v-card-text>
            <v-data-table item-key="name" :single-expand="singleExpand" :expanded.sync="expanded" :headers="headers"
              :items="PNLReport" sort-by="name" hide-default-footer :items-per-page="PNLReport.length">
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>Location List</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-switch v-model="singleExpand" label="Single expand" class="mt-2"></v-switch>
                </v-toolbar>
              </template>
              <template v-slot:item="{ item, isExpanded, expand }">
                <tr>
                  <!-- <td class="text-left small-td pointer" v-if="hidden">
                <v-checkbox :input-value="selected" hide-details> </v-checkbox>
              </td> -->


                  <td class="text-left small-td pointer">
                    <v-btn @click="expand(true)" icon v-if="!isExpanded">
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                    <v-btn @click="expand(false)" icon v-if="isExpanded">
                      <v-icon>mdi-chevron-up</v-icon>
                    </v-btn>
                    {{ item.name }}
                  </td>
                  <td class="text-right small-td pointer" @click="viewLocation(item)">

                    <div v-if="item.Itemized && item.Itemized[0] && item.Itemized[0].SaleAmount">{{
                    item.Itemized[0].SaleAmount | currency }}</div>
                    <div v-else>{{ 0 | currency }}</div>


                  </td>
                  <td class="text-right small-td pointer" @click="viewLocation(item)">
                    <div v-if="item.Payments && item.Payments[0] && item.Payments[0].SaleAmount">{{
                    item.Payments[0].SaleAmount | currency }}</div>
                    <div v-else>{{ 0 | currency }}</div>
                  </td>
                  <td class="text-right small-td pointer" @click="viewLocation(item)">
                    <div v-if="item.Serialized && item.Serialized[0] && item.Serialized[0].SaleAmount">{{
                    item.Serialized[0].SaleAmount | currency }}</div>
                    <div v-else>{{ 0 | currency }}</div>
                  </td>
                  <td class="text-right small-td pointer" @click="viewLocation(item)">
                    <div v-if="item.Services && item.Services[0] && item.Services[0].SaleAmount">{{
                    item.Services[0].SaleAmount | currency }}</div>
                    <div v-else>{{ 0 | currency }}</div>
                  </td>
                  <td class="text-right small-td pointer" @click="viewLocation(item)">
                    <div v-if="item.RepairDevices && item.RepairDevices[0] && item.RepairDevices[0].SaleAmount">{{
                    item.RepairDevices[0].SaleAmount | currency }}</div>
                    <div v-else>{{ 0 | currency }}</div>
                  </td>
                  <td class="text-right small-td pointer" @click="viewLocation(item)">
                    <div v-if="item.RepairParts && item.RepairParts[0] && item.RepairParts[0].SaleAmount">{{
                    item.RepairParts[0].SaleAmount | currency }}</div>
                    <div v-else>{{ 0 | currency }}</div>
                  </td>
                  <td class="text-right small-td pointer" @click="viewLocation(item)">{{ item.totalSale | currency }}
                  </td>
                  <td :class="foreColor(item.profit)" class="text-right small-td pointer  font-weight-bold">
                    {{ item.profit | currency }}
                  </td>
                </tr>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="pa-0">
                  <v-card color="blue-grey darken-4" dark>
                    <SubCategoryList showMainCategory="true" :dateTime="dateTime" :location="item.location" />
                  </v-card>
                </td>
              </template>
              <template v-if="total" v-slot:body.append="{ headers }">
                <tr style="background: #EEEEEE">
                  <!-- <td class="text-right font-weight-bold" :colspan="headers.length - 8">
                    Total
                  </td> -->
                  <td class="text-right font-weight-bold" v-for="(value, index) in headers" :key="index">
                    <!-- {{value.value}} -->
                    <div v-if="total[`${value.value}`] !== 'Total'">{{total[`${value.value}`] | currency}}</div>
                    <div v-else>Total</div>
                    <!-- {{value}} -->
                    <!-- <div v-if="total[`${value.text}`]">{{total[`${value.text}`] | currency}}</div> -->
                  </td>
                  <!-- <div v-for="(value, index) in headers" :key="index">
                    <td v-if="total[`${value.text}`]">
                      {{total[`${value.text}`] | currency}}
                    </td>
                  </div> -->
                  <!-- <td class="text-right font-weight-bold">
                    {{ total | currency }}
                  </td>
                  <td class="text-right font-weight-bold">
                    {{ payment | currency }}
                  </td>
                  <td class="text-right font-weight-bold">
                    {{ balance | currency }}
                  </td>
                  <td></td> -->
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>







  </v-container>
</template>
<script>
// import GroupList from "../components/List";
import reportService from '@/pages/Report/service.js'
import { mapGetters } from 'vuex';
import _ from "lodash";
import DateTimePicker from '@/components/DateTimePicker.vue'
import SubCategoryList from '@/pages/Report/components/SubCategoryList.vue'

export default {
  name: "all-store-pnl-report",
  data() {
    return {
      total: {},
      selectedDate: null,
      dateTime: {
        start: null,
        end: null,
      },
      expanded: [],
      singleExpand: true,
      menu: false,
      loading: true,
      selectedLocation: null,
      CategoryPNL: [],
      categoryTiles: {},
      PNLReport: [],
      headers: [
        {
          text: 'Location',
          align: "left",
          sortable: false,
          value: "CSPID"
        },
        {
          text: 'Itemized',
          value: "Itemized",
          sortable: false
        },
        {
          text: 'Payments',
          value: "Payments",
          sortable: false
        },
        {
          text: 'Serialized',
          value: "Serialized",
          sortable: false
        },
        {
          text: 'Services',
          value: "Services",
          sortable: false
        },
        {
          text: 'Repair Devices',
          value: "RepairDevices",
          sortable: false
        },
        {
          text: 'Repair Parts',
          value: "RepairParts",
          sortable: false
        },
        {
          text: 'Total Sale',
          align: 'right',
          value: "totalSale",
          sortable: false
        },
        {
          text: 'Profit',
          align: 'right',
          value: "profit",
          sortable: false
        }
      ],

    }
  },
  components: {
    DateTimePicker,
    SubCategoryList,
  },
  computed: {
    ...mapGetters('location', ['locations']),
  },
  created() {
    if (this.locations.length !== 0) {
      this.saleByCategory()
      this.profitAndLose()
    }
  },
  watch: {
    locations() {
      this.saleByCategory();
      this.profitAndLose()
    },
    // dates(val) {
    //   console.log('watch date', val)
    // }
  },
  methods: {
    foreColor(val) {
      let color = 'green--text'
      if (val < 0) {
        color = 'red--text'
      }
      return color
    },
    async viewLocation(item) {
      await Promise.all(
        this.locations.map(row => {
          // console.log('location', row.storeID, item.id)
          if (row.storeID === item.id) {
            // console.log('this is location ', row)
            this.selectedLocation = row
          }
        })
      )
      // console.log('selectedLocation', this.selectedLocation)

      this.$router.push({ name: 'report-profile', params: { location: this.selectedLocation, item: item, date: this.dateTime } });
    },
    closeDatePicker() {
      // console.log('submit got call', this.dateTime)
      // // this.$refs.menu.save(this.dates)
      this.saleByCategory()
      this.profitAndLose()
      // console.log('dates', this.dates)
    },
    nFormatter(num) {
      if (num >= 1000000000) {
        return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G';
      }
      if (num >= 1000000) {
        return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
      }
      if (num >= 1000) {
        return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
      }
      return num;
    },
    iconValue(val) {
      // console.log('val', val)
      let icon = 'mdi-cellphone'
      switch (val) {
        case 'Itemized':
          icon = 'mdi-headphones'
          break;
        case 'Serialized':
          icon = 'mdi-cellphone'
          break;
        case 'Repair Parts':
          icon = 'mdi-toolbox-outline'
          break;
        case 'Payments':
          icon = 'mdi-cash-100'
          break;
        default:
          icon = 'mdi-cellphone'
      }
      return icon
    },
    iconForeground(val) {
      let color = 'blue darken-4'
      switch (val) {
        case 'Itemized':
          color = 'red darken-4'
          break;
        case 'Services':
          color = 'cyan darken-4'
          break;
        case 'Repair Devices':
          color = 'lime darken-4'
          break;
        case 'Repair Parts':
          color = 'green darken-4'
          break;
        case 'Payments':
          color = 'deep-purple darken-4'
          break;
        case 'Serialized':
          color = 'blue darken-4'
          break;
        default:
          color = 'blue darken-4'
      }
      return color
    },
    iconColor(val) {
      let color = 'blue lighten-5'
      switch (val) {
        case 'Itemized':
          color = 'red lighten-5'
          break;
        case 'Repair Parts':
          color = 'green lighten-5'
          break;
        case 'Repair Devices':
          color = 'lime lighten-5'
          break;
        case 'Services':
          color = 'cyan lighten-5'
          break;
        case 'Payments':
          color = 'deep-purple lighten-5'
          break;
        case 'Serialized':
          color = 'blue lighten-5'
          break;
        default:
          color = 'blue lighten-5'
      }
      return color
    },

    async profitAndLose() {
      if (!this.dateTime.start) return false
      // console.log('category got call', this.locations.length)
      this.loading = true
      // let list = []
      this.PNLReport = []
      Promise.all(this.locations.map(location => {
        try {
          return reportService
            .profitAndLose(location.storeID, { from: this.dateTime.start.split("T")[0], to: this.dateTime.end.split("T")[0] })
            .then(response => {
              console.log('profitAndLose', response)
              let totalSale = 0
              let totalProfit = 0
              response.data.map(row => {
                row.profit = parseFloat(row.SaleAmount) - parseFloat(row.CostAmount) - parseFloat(row.DetailDiscount)
                totalSale += parseFloat(row.SaleAmount)
                totalProfit += row.profit
              })
              const saleData = _.groupBy(response.data, (value) => {
                // console.log('value', value)
                return value.MainCategoryName.replace(/ /g, "")
              })

              this.PNLReport.push({
                id: location.storeID,
                name: location.businessName,
                profit: totalProfit,
                totalSale: totalSale,
                location: location,
                ...saleData
              })

              // console.log('saleData', saleData)

              return response;
            }).catch(err => {
              console.log('err', err)
              this.$swal('Please update you software')
              this.$router.push({ path: `/home` })
            })
        } catch (error) {
          console.log('error', error)
        }
        // console.log('location', location.CSPID)
        // total = {
        //   Itemized: <total>,
        //   Payments: <total>,

        // }

      })).then(() => {
        let total = {};
        this.total = null;
        this.PNLReport.map(row => {
          Object.keys(row).forEach(key => {
            // for values having array
            if (Array.isArray(row[`${key}`])) {
              if (total[`${key}`]) {
                total[`${key}`] = total[`${key}`] + parseFloat(row[`${key}`][0].SaleAmount);
              } else {
                total[`${key}`] = parseFloat(row[`${key}`][0].SaleAmount);
              }
            }
            // doing it just for profit and total Sale since data structure is different 
            // console.log('row[key]', row, key)
            if (key == 'totalSale' || key == 'profit') {

              if (total[key]) {
                total[key] = total[key] + parseFloat(row[key]);
              } else {
                total[key] = parseFloat(row[key])
              }
            }
          })
          // total[`totalSale`] = (parseFloat(row['totalSale']) || 0 );
          // total[`profit`] = parseFloat(row['profit']);
        })
        this.total = total;
        this.total.CSPID = 'Total'
        console.log('total is :', this.total);
      })
      console.log('this.PNLReport', this.PNLReport)

    },
    async saleByCategory() {
      // console.log('category got call', this.locations.length)
      if (!this.dateTime.start) return false
      this.loading = true
      this.CategoryPNL = []
      return Promise.all(this.locations.map(location => {
        // console.log('location', location.CSPID)
        return reportService
          .saleByCategory(location.storeID, { from: this.dateTime.start.split("T")[0], to: this.dateTime.end.split("T")[0] })
          .then(response => {
            // console.log("CategoryPNL", response);
            this.CategoryPNL.push(response.data)
            return response;
          }).catch(err => {
            console.log('err', err)
            this.$swal('Please update you software')
            this.$router.push({ path: `/home` })
          })
      }))
        .then(promiseDone => {
          this.buildCategoryData()

        })
      // console.log('this.CategoryPNL', this.CategoryPNL)
    },
    buildCategoryData() {
      this.categoryTiles = {}
      this.CategoryPNL.forEach((location) => {
        location.forEach(row => {
          if (this.categoryTiles[row.MainCategoryName]) {
            this.categoryTiles[row.MainCategoryName] += parseFloat(row.SaleAmount)
          } else {
            this.categoryTiles[row.MainCategoryName] = parseFloat(row.SaleAmount)
          }
        })
      })
      // this.$forceUpdate();
      this.loading = false
    },
  },
};
</script>
